import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import type {ListItem} from 'nutshell-core/types';

import {LeadCardDynamicWrapper} from '../../lead/lead-card-dynamic';

import styles from './preview-lead-card.module.css';

type Props = {
    listItem: ListItem;
    fieldsToDisplay: string[];
};
export function PreviewLeadCard(props: Props) {
    React.useEffect(() => {
        ReactTooltip.hide();
    }, []);

    return (
        <div className={styles['card-container']}>
            <LeadCardDynamicWrapper
                isDragging={true}
                listItem={props.listItem}
                hasActionMenu={false}
                linkable={false}
                fieldsToDisplay={props.fieldsToDisplay}
            />
        </div>
    );
}
